import { render, staticRenderFns } from "./PromotionForm.vue?vue&type=template&id=cad9edee&scoped=true"
import script from "./PromotionForm.vue?vue&type=script&lang=js"
export * from "./PromotionForm.vue?vue&type=script&lang=js"
import style0 from "./PromotionForm.vue?vue&type=style&index=0&id=cad9edee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad9edee",
  null
  
)

export default component.exports